import { ROLES } from "../../const/roles"
import type { ApiRoleStrategy } from "../../hooks"

const queryKey = ["sectors", "dataref"]
const endpoint = "/api/sectors/dataref?size=-1"

const adhConf = {
  queryKey: ["sectors", "adherent", "dataref"],
  endpoint: "/api/sectors/adherent/dataref",
}

export const sectorDataRefApiRoleConf = (): ApiRoleStrategy => ({
  [ROLES.ADMIN]: { queryKey, endpoint },
  [ROLES.ADHERENT_HOLDER]: adhConf,
  [ROLES.ADHERENT_TEAM]: adhConf,
  [ROLES.UPP_PRESIDENT]: { queryKey, endpoint },
  [ROLES.UPP_REPRESENTATIVE]: { queryKey, endpoint },
  [ROLES.EXTERN_CONTACT_LABORATORY]: { queryKey, endpoint },
})
